import Swiper from 'swiper';

export default function() {
  const defaultConfig = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 30,
    preloadImages: true,
    updateOnImagesReady: true,
    effect: 'fade',
    watchOverflow: true,
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };

  // Configuration overrides
  const configurations = new Map();

  configurations.set('simple-slider', {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 30,
    preloadImages: true,
    updateOnImagesReady: true,
    autoHeight: true,
    effect: 'fade',
    watchOverflow: true,
    fadeEffect: { crossFade: true },
    loop: true,
    navigation: {
      nextEl: '.js-slider-next',
      prevEl: '.js-slider-previous',
    },
  });

  configurations.set('upsell-slider', {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 10,
    preloadImages: true,
    updateOnImagesReady: true,
    loop: false,
    watchOverflow: true,
    navigation: {
      nextEl: '.js-upsell-next',
      prevEl: '.js-upsell-prev',
    },
    breakpoints: {
      480: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 2,
      },
    },
  });

  configurations.set('category-slider', {
    direction: 'horizontal',
    slidesPerView: 1.5,
    spaceBetween: 40,
    preloadImages: true,
    freeMode: true,
    freeModeMomentumVelocityRatio: 0.5,
    updateOnImagesReady: true,
    loop: false,
    watchOverflow: true,
    navigation: {
      nextEl: '.js-slider-next',
      prevEl: '.js-slider-previous',
    },
    breakpoints: {
      480: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });

  const getActiveSlideIndex = sliderEl => {
    const activeSlide = sliderEl.querySelector('.swiper-slide-active');
    let activeSlideIndex = 0;
    let index = 0;
    [...sliderEl.querySelectorAll('.swiper-slide')].forEach(slide => {
      if (slide === activeSlide) {
        activeSlideIndex = index;
      }
      index += 1;
    });
    return activeSlideIndex;
  };

  // Init sliders
  const sliders = [...document.querySelectorAll('.js-slider')];
  sliders.forEach(sliderEl => {
    let config = configurations.get(sliderEl.dataset.config);
    if (!config) {
      config = defaultConfig;
    }
    const activeSlide = sliderEl.querySelector('.swiper-slide-active');
    if (activeSlide) {
      config.initialSlide = getActiveSlideIndex(sliderEl);
    }
    const slider = new Swiper(sliderEl.querySelector('.swiper-container'), config);
    slider.init();
  });
}
